<template>
    <div class="scroll-container">
        <div class="container1">
            <div class="title">机构认证（已认证）</div>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                class="dialogForm"
                label-width="160px"
                style="width: 50%; padding: 30px 0;"
            >

              <el-form-item label="企业logo" prop="image">
                <!-- <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="uploadedFiles"> -->
                  <img v-if="form.image" :src="baseUrl+form.image" class="avatar">
                  <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                <!-- </el-upload> -->
              </el-form-item>
              <el-form-item label="企业名称" prop="qymc">
                  <el-input
                      v-model="form.qymc"
                      clearable
                      placeholder="请输入"
                      show-word-limit
                      :disabled="true"
                  />
              </el-form-item>
              <el-form-item label="社会统一信用代码" prop="dm">
                  <el-input
                      v-model="form.dm"
                      clearable
                      placeholder="请输入"
                      show-word-limit
                      :disabled="true"
                  />
              </el-form-item>
              <el-form-item label="法定代表人" prop="fddbr">
                  <el-input
                      v-model="form.fddbr"
                      clearable
                      placeholder="请输入"
                      show-word-limit
                      :disabled="true"
                  />
              </el-form-item>
              <el-form-item label="身份证号" prop="fddbrsfzh">
                  <el-input
                      v-model="form.fddbrsfzh"
                      clearable
                      placeholder="请输入"
                      show-word-limit
                      :disabled="true"
                  />
              </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { uploadFiles } from '@/api/index'
import {getFinancialInsDetails} from "@/views/financInstitutionPC/viewApi";

export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_API,
      form:{
        qymc:'',
        image:''
      },
      rules:{},
    }
  },
  mounted() {
    this.queryData();
  },
  methods: {
    queryData(){
      getFinancialInsDetails().then(res => {
        if (res.code == 1000) {
          this.form={...res.data}
        }
      })
    },

    //上传
    uploadedFiles (file) {
        let formData = new FormData();
        formData.append('file', file)  
        uploadFiles(formData).then(( res )=>{
          if(res.data){
            this.form.image = res.data.url
          }
        })
    },
    handleAvatarSuccess(res, file) {
      this.form.image = URL.createObjectURL(file.raw);
    },

  }
};
</script>
<style lang="scss" >
.scroll-container{

  .container1{
      background: white;
      border-radius: 16px;
      height: 100%;
      .title{
          margin-top: 10px;
          margin-left: 5px;
          height: 35px;
          width: 100%;
          line-height: 35px;
          font-size: 15px;
          font-weight: 800;
          border-bottom: 1px solid #c4c6ca;
      }

  }
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>